import { blue } from "@mui/material/colors";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { makeModeAwareAccent } from "@entrilia/shared/utilities/colorHelper";

const NewLabel = () => <StatusChip label="New" color={(t) => makeModeAwareAccent(t, blue)} height="smaller" />;

export default NewLabel;
